(function () {
  // Country names → ISO 3166-1 alpha-2 codes
  // US states and Canadian provinces are already 2-letter codes from the Seated widget
  var COUNTRY_ABBR = {
    'CANADA': 'CA',
    'UNITED STATES': 'US',
    'UNITED KINGDOM': 'UK',
    'ENGLAND': 'UK',
    'SCOTLAND': 'UK',
    'WALES': 'UK',
    'AUSTRALIA': 'AU',
    'GERMANY': 'DE',
    'FRANCE': 'FR',
    'NETHERLANDS': 'NL',
    'BELGIUM': 'BE',
    'SPAIN': 'ES',
    'ITALY': 'IT',
    'SWEDEN': 'SE',
    'NORWAY': 'NO',
    'DENMARK': 'DK',
    'FINLAND': 'FI',
    'SWITZERLAND': 'CH',
    'AUSTRIA': 'AT',
    'IRELAND': 'IE',
    'PORTUGAL': 'PT',
    'POLAND': 'PL',
    'JAPAN': 'JP',
    'MEXICO': 'MX',
    'BRAZIL': 'BR',
    'ARGENTINA': 'AR',
    'CHILE': 'CL',
    'COLOMBIA': 'CO',
    'NEW ZEALAND': 'NZ'
  };

  var MONTH_MAP = {
    'JAN':'01','FEB':'02','MAR':'03','APR':'04','MAY':'05','JUN':'06',
    'JUL':'07','AUG':'08','SEP':'09','OCT':'10','NOV':'11','DEC':'12'
  };

  function processDates() {
    document.querySelectorAll('#seated-55fdf2c0 .seated-event-date-cell').forEach(function (el) {
      if (el.dataset.dateDone) return;
      var text = el.textContent.trim();
      if (!text) return;
      // Parse "Apr 24, 2026" → ["Apr", "24,", "2026"]
      var parts = text.replace(',', '').split(/\s+/);
      if (parts.length < 3) return;
      var mm = MONTH_MAP[parts[0].toUpperCase().slice(0, 3)];
      var dd = String(parseInt(parts[1], 10)).padStart(2, '0');
      var yy = String(parseInt(parts[2], 10)).slice(-2);
      if (!mm || !dd || !yy) return;
      el.dataset.dateDone = '1';
      el.textContent = mm + '.' + dd + '.' + yy;
    });
  }

  function processLocations() {
    document.querySelectorAll('#seated-55fdf2c0 .seated-event-venue-location').forEach(function (el) {
      if (el.dataset.abbrDone) return;
      el.dataset.abbrDone = '1';
      var text = el.textContent.trim();
      var parts = text.split(',');
      if (parts.length < 2) return;
      var city = parts.slice(0, -1).join(',').trim();
      var region = parts[parts.length - 1].trim().toUpperCase();
      var abbr = COUNTRY_ABBR[region] || region;

      var cityNode = document.createElement('span');
      cityNode.textContent = city;

      var countryNode = document.createElement('span');
      countryNode.className = 'tour-location__country';
      countryNode.textContent = '\u00A0' + abbr;

      el.textContent = '';
      el.appendChild(cityNode);
      el.appendChild(countryNode);
    });
  }

  var target = document.getElementById('seated-55fdf2c0') || document.body;
  var observer = new MutationObserver(function () {
    processDates();
    processLocations();
  });
  observer.observe(target, { childList: true, subtree: true, characterData: true });
  processDates();
  processLocations();
})();
